import React from "react";
import Layout from "../../layout/Layout";
import Fade from "react-reveal";

export default function Terms() {
  return (
    <Layout>
      <div className="container mx-auto px-3 mt-8">
        <Fade bottom>
          <h4 className="mb-8 text-center font-semibold text-3xl py-5 uppercase">
            Terms And Conditions
          </h4>
          <p>
            <b className="text-xl">THE AGREEMENT:</b> The use of this website
            and products on this website provided by Aperians (hereinafter
            referred to as "Company") are subject to the following Terms &
            Conditions (hereinafter the "Agreement"), all parts and sub-parts of
            which are specifically incorporated by reference here. This
            Agreement shall govern the use of all pages on this website
            (hereinafter collectively referred to as "Website") and any digital
            artworks and collectibles provided by or on this Website ("NFTs").
          </p>
          <br />
          <br />
        </Fade>

        <Fade bottom>
          <b className="text-xl">1) DEFINITIONS</b>
          <ul className="px-5">
            <li>
              a) Company, Us, We: The Company, as the creator, operator, and
              publisher of the Website, makes the Website, and certain NFTs on
              it, available to users. Company, Us, We, Our, Ours and other
              first-person pronouns will refer to the Company, as well as all
              employees and affiliates of the Company.
            </li>
            <li>
              b) You, the User, the Client: You, as the user of the Website,
              will be referred to throughout this Agreement with second-person
              pronouns such as You, Your, Yours, or as User or Client.
            </li>
            <li>
              c) Parties: Collectively, the parties to this Agreement (the
              Company and You) will be referred to as Parties.
            </li>
          </ul>
          <br />
          <br />
        </Fade>

        <Fade bottom>
          <b className="text-xl">2) ASSENT & ACCEPTANCE</b>
          <p>
            By using the Website, You warrant that You have read and reviewed
            this Agreement and that You agree to be bound by it. If You do not
            agree to be bound by this Agreement, please leave the Website
            immediately. The Company only agrees to provide use of this Website
            and NFTs to You if You assent to this Agreement.
          </p>
          <p>
            APERIANS is a collection of 9001 unique hand crafted and randomly
            generated NFTs, upgradable with custom skills, visuals and more
            (NFTs). This Website is only an interface allowing participants to
            purchase digital collectibles. Users are entirely responsible for
            the safety and management of their own private wallets and
            validating all transactions and contracts generated by this Website
            before approval. Furthermore, as the APERIANS smart contract runs on
            the Ethereum network, there is no ability to undo, reverse, or
            restore any transactions.
          </p>
          <br />
          <br />
        </Fade>

        <Fade bottom>
          <b className="text-xl">3) AGE RESTRICTION</b>
          <p>
            You must be at least 18 (eighteen) years of age to use this Website
            or any NFTs contained herein. By using this Website, You represent
            and warrant that You are at least 18 years of age and may legally
            agree to this Agreement. The Company assumes no responsibility or
            liability for any misrepresentation of Your age.
          </p>

          <br />
          <br />
        </Fade>
        <Fade bottom>
          <b className="text-xl">4) TRANSFER OF RIGHTS AND LICENSE</b>
          <p>
            The APERIANS collection is built on the Ethereum blockchain. When
            you purchase an NFT, we transfer you the ownership of the underlying
            NFT completely. Ownership of the NFT is mediated entirely by the
            Smart Contract and the Ethereum Network: at no point may we seize,
            freeze, or otherwise modify the ownership of any NFTs.
          </p>
          <p>
            Subject to your continued compliance with these Terms, we grant you
            a worldwide, royalty-free license to use, copy, and display the
            purchased art, along with any extensions that you choose to create
            or use, solely for the following purposes: (i) for your own
            personal, non-commercial use; (ii) as part of a marketplace that
            permits the purchase and sale of your NFT, provided that the
            marketplace cryptographically verifies each NFT owner’s rights to
            display the art for their NFT to ensure that only the actual owner
            can display the art; or (iii) as part of a third party website or
            application that permits the inclusion, involvement, or
            participation of your NFT, provided that the website/application
            cryptographically verifies each NFT owner’s rights to display the
            art for their NFT to ensure that only the actual owner can display
            the art, and provided that the Art is no longer visible once the
            owner of the NFT leaves the website/application.
          </p>
          <p>
            Subject to your continued compliance with these Terms, we grant you
            an unlimited, worldwide license to use, copy, and display the
            purchased art for the purpose of creating derivative works based
            upon the art (“Commercial Use”). Examples of such Commercial Use
            would e.g. be the use of the art to produce and sell merchandise
            products (T-Shirts etc.) displaying copies of the art. For the sake
            of clarity, nothing in this Section will be deemed to restrict you
            from (i) owning or operating a marketplace that permits the use and
            sale of NFTs generally, provided that the marketplace
            cryptographically verifies each NFT owner’s rights to display the
            art for their NFT to ensure that only the actual owner can display
            the art; (ii) owning or operating a third party website or
            application that permits the inclusion, involvement, or
            participation of APERIANS, provided that the third party website or
            application cryptographically verifies each NFT owner’s rights to
            display the art for their NFT to ensure that only the actual owner
            can display the art, and provided that the art is no longer visible
            once the owner of the purchased NFT leaves the website/application;
            or (iii) earning revenue from any of the foregoing.
          </p>
          <br />
          <br />
        </Fade>
        <Fade bottom>
          <b className="text-xl">5) COMPANY’S INTELLECTUAL PROPERTY</b>
          <p>
            Other than the rights to the particular NFT, nothing herein gives
            you any rights to any other trademarks or other intellectual
            property rights belonging to NFT Espresso Ltd, including, without
            limitation to, NFT Espresso Ltd and the associated logos ("Company
            IP"). All of these rights are expressly reserved in the name of NFT
            Espresso Ltd. You agree that the Company owns all rights, title and
            interest in and to the Company IP and that You will not use the
            Company IP for any unlawful or infringing purpose. You agree not to
            reproduce or distribute the Company IP in any way, including
            electronically or via registration of any new trademarks, trade
            names, product marks or Uniform Resource Locators (URLs), without
            express written permission from the Company.
          </p>
          <br />
          <br />
        </Fade>
        <Fade bottom>
          <b className="text-xl">6) ACCEPTABLE USE</b>
          <p>
            You agree not to use the Website or NFTs for any unlawful purpose or
            any purpose prohibited under this clause. You agree not to use the
            Website or NFTs in any way that could damage the Website or general
            business of the Company.
          </p>

          <p>a) You further agree not to use the Website:</p>
          <ul className="px-5">
            <li>
              I) To harass, abuse, or threaten others or otherwise violate any
              person's legal rights;
            </li>
            <li>
              II) To violate any intellectual property rights of the Company or
              any thirdparty;
            </li>
            <li>
              III) To upload or otherwise disseminate any computer viruses or
              other software that may damage the property of another
            </li>
            <li>IV) To perpetrate any fraud;</li>
            <li>
              V) To engage in or create any unlawful gambling, sweepstakes, or
              pyramid scheme;
            </li>
            <li>
              VI) To publish or distribute any obscene or defamatory material;
            </li>
            <li>
              VII) To publish or distribute any material that incites violence,
              hate, or discrimination towards any group;
            </li>
            <li>VIII) To unlawfully gather information about others.</li>
          </ul>
        </Fade>

        <Fade bottom>
          <br />
          <br />
          <b className="text-xl">7) FEES AND PAYMENT</b>
          <p>
            If you elect to purchase an NFT through the site, any financial
            transactions that you engage in will be conducted solely through the
            Ethereum network. We will have no insight into or control over these
            payments or transactions, nor do we have the ability to reverse any
            transactions. We will have no liability to you or to any third party
            for any claims or damages that may arise as a result of any
            transactions that you engage or any other transactions that you
            conduct via the Ethereum network.
          </p>
          <p>
            Ethereum requires the payment of a transaction fee (a “Gas Fee”) for
            every transaction that occurs on the Ethereum network. The Gas Fee
            funds the network of computers that run the decentralized Ethereum
            network. This means that you will need to pay a Gas Fee for each
            transaction.
          </p>
          <br />
          <b className="text-xl">8) UTILITY</b>
          <p>
            Subject to the sellout of the Collection, NFT holders shall have the
            following benefits:
          </p>
          <br />
        </Fade>
        <Fade bottom>
          <p>APERIANS GENESIS</p>
          <ul className="px-5">
            <li>
              5% of the trading revenue distributed to the holders on a monthly
              basis.
            </li>
            {/* <li>8 weeks of giveaways for the community, including a brand new Tesla.</li> */}
            <li>monthly token airdrops for each holder.</li>
            <li>DAO Governance that makes each holder a part of the team.</li>
            <li>lifetime access to the Aperians Club</li>
            <li>Access to exclusive drops and social events.</li>
          </ul>
          <br />
        </Fade>
        <Fade bottom>
          <p>
            For more information on the benefits, please consult our Roadmap.
          </p>

          <br />
          <br />
        </Fade>
        <Fade bottom>
          <b className="text-xl">9) PRIVACY INFORMATION</b>
          <p>
            Through Your Use of the Website and NFTs, You may provide Us with
            certain information.
          </p>
          <ul className="px-5">
            <li>
              a) Information We May Collect or Receive: When You register for an
              account, You provide Us with a valid email address and may provide
              Us with additional information, such as Your name or billing
              information. Depending on how You use Our Website or NFTs, We may
              also receive information from external applications that You use
              to access Our Website, or We may receive information through
              various web technologies, such as cookies, log files, clear gifs,
              web beacons or others
            </li>
            <li>
              b) How We Use Information: We use the information gathered from
              You to ensure Your continued good experience on Our website,
              including through email communication. We may also track certain
              aspects of the passive information received to improve Our
              marketing and analytics, and for this, We may work with
              third-party providers.
            </li>
            <li>
              c) How You Can Protect Your Information: If You would like to
              disable Our access to any passive information We receive from the
              use of various technologies, You may choose to disable cookies in
              Your web browser. Please be aware that the Company will still
              receive information about You that You have provided, such as Your
              email address.
            </li>
          </ul>
        </Fade>

        <Fade bottom>
          <br />
          <br />
          <b className="text-xl">10) REVERSE ENGINEERING & SECURITY</b>
          <p>You agree not to undertake any of the following actions:</p>
          <ul className="px-5">
            <li>
              a) Reverse engineer, or attempt to reverse engineer or disassemble
              any code or software from or on the Website;
            </li>
            <li>
              b) Violate the security of the Website through any unauthorized
              access, circumvention of encryption or other security tools, data
              mining or interference to any host, user or network.
            </li>
          </ul>
        </Fade>
        <Fade bottom>
          <br />
          <br />
          <b className="text-xl">11) INDEMNIFICATION</b>
          <p>
            You agree to defend and indemnify the Company and any of its
            affiliates (if applicable) and hold Us harmless against any and all
            legal claims and demands, including reasonable attorney's fees,
            which may arise from or relate to Your use or misuse of the Website
            or NFTs, Your breach of this Agreement, or Your conduct or actions.
            You agree that the Company shall be able to select its own legal
            counsel and may participate in its own defense, if the Company
            wishes.
          </p>
        </Fade>
        <Fade bottom>
          <br />
          <br />
          <b className="text-xl">12) THIRD-PARTY LINKS & CONTENT</b>
          <p>
            The Company may occasionally post links to third party websites or
            other products. You agree that the Company is not responsible or
            liable for any loss or damage caused as a result of Your use of any
            third-party products linked to from Our Website.
          </p>
          <br />
          <br />
        </Fade>
        <Fade bottom>
          <b className="text-xl">13) MODIFICATION & VARIATION</b>
          <p>
            The Company may, from time to time and at any time without notice to
            You, modify this Agreement. You agree that the Company has the right
            to modify this Agreement or revise anything contained herein. You
            further agree that all modifications to this Agreement are in full
            force and effect immediately upon posting on the Website and that
            modifications or variations will replace any prior version of this
            Agreement, unless prior versions are specifically referred to or
            incorporated into the latest modification or variation of this
            Agreement.
          </p>
          <ul className="px-5">
            <li>
              a) To the extent any part or sub-part of this Agreement is held
              ineffective or invalid by any court of law, You agree that the
              prior, effective version of this Agreement shall be considered
              enforceable and valid to the fullest extent.
            </li>
            <li>
              b) You agree to routinely monitor this Agreement and refer to the
              Effective Date posted at the top of this Agreement to note
              modifications or variations. You further agree to clear Your cache
              when doing so to avoid accessing a prior version of this
              Agreement. You agree that Your continued use of the Website after
              any modifications to this Agreement is a manifestation of Your
              continued assent to this Agreement.
            </li>
            <li>
              c) In the event that You fail to monitor any modifications to or
              variations of this Agreement, You agree that such failure shall be
              considered an affirmative waiver of Your right to review the
              modified Agreement.
            </li>
          </ul>
          <br />
          <br />
        </Fade>
        <Fade bottom>
          <b className="text-xl">14) ENTIRE AGREEMENT</b>
          <p>
            This Agreement constitutes the entire understanding between the
            Parties with respect to any and all use of this Website. This
            Agreement supersedes and replaces all prior or contemporaneous
            agreements or understandings, written or oral, regarding the use of
            this Website.
          </p>
          <br />
          <br />
        </Fade>
        <Fade bottom>
          <b className="text-xl">15) NO WARRANTIES</b>
          <p>
            You agree that Your use of the Website and NFTs is at Your sole and
            exclusive risk and that any services provided by Us are on an "As
            Is" basis. The Company hereby expressly disclaims any and all
            express or implied warranties of any kind, including, but not
            limited to the implied warranty of fitness for a particular purpose
            and the implied warranty of merchantability. The Company makes no
            warranties that the Website or NFTs will meet Your needs. The
            Company also makes no warranties as to the reliability or accuracy
            of any information on the Website. You agree that any damage that
            may occur to You, through Your computer system, or as a result of
            loss of Your data from Your use of the Website or NFTs is Your sole
            responsibility and that the Company is not liable for any such
            damage or loss
          </p>

          <br />
          <br />
        </Fade>
        <Fade bottom>
          <b className="text-xl">16) LIMITATION ON LIABILITY</b>
          <p>
            The Company is not liable for any damages that may occur to You as a
            result of Your use of the Website or NFTs, to the fullest extent
            permitted by law. The maximum liability of the Company arising from
            or relating to this Agreement is limited to the greater of one
            hundred ($100) US Dollars or the amount You paid to the Company in
            the last six (6) months. This section applies to any and all claims
            by You, including, but not limited to, lost profits or revenues,
            consequential or punitive damages, negligence, strict liability,
            fraud, or torts of any kind.
          </p>
          <br />
          <br />
        </Fade>
        <Fade bottom>
          <b className="text-xl">17) GENERAL PROVISIONS:</b>
          <ul className="px-5">
            <li>
              <b>a) LANGUAGE: </b>All communications made or notices given
              pursuant to this Agreement shall be in the English language.
            </li>
            <li>
              <b>b) JURISDICTION, VENUE & CHOICE OF LAW: </b>Through Your use of
              the Website or NFTs, You agree that the laws from the Company’s
              headquarters shall govern any matter or dispute relating to or
              arising out of this Agreement, as well as any dispute of any kind
              that may arise between You and the Company, with the exception of
              its conflict of law provisions.
            </li>
            <li>
              <b>c) GOOD FAITH RESOLUTION: </b>n case of a dispute between the
              Parties relating to or arising out of this Agreement, the Parties
              shall first attempt to resolve the dispute personally and in good
              faith.
            </li>
            <li>
              <b>d) ASSIGNMENT: </b>This Agreement, or the rights granted
              hereunder, may not be assigned, sold, leased or otherwise
              transferred in whole or part by You. Should this Agreement, or the
              rights granted hereunder, by assigned, sold, leased or otherwise
              transferred by the Company, the rights and liabilities of the
              Company will bind and inure to any assignees, administrators,
              successors, and executors.
            </li>
            <li>
              <b>e) SEVERABILITY: </b>f any part or sub-part of this Agreement
              is held invalid or unenforceable by a court of law or competent
              arbitrator, the remaining parts and sub-parts will be enforced to
              the maximum extent possible. In such condition, the remainder of
              this Agreement shall continue in full force.
            </li>
            <li>
              <b>) NO WAIVER:</b>n the event that We fail to enforce any
              provision of this Agreement, this shall not constitute a waiver of
              any future enforcement of that provision or of any other
              provision. Waiver of any part or sub-part of this Agreement will
              not constitute a waiver of any other part or sub-part
            </li>
            <li>
              <b>g) HEADINGS FOR CONVENIENCE ONLY: </b>Headings of parts and
              sub- parts under this Agreement are for convenience and
              organization, only. Headings shall not affect the meaning of any
              provisions of this Agreement.
            </li>
            <li>
              <b>h) NO AGENCY, PARTNERSHIP OR JOINT VENTURE:</b>No agency,
              partnership, or joint venture has been created between the Parties
              as a result of this Agreement. No Party has any authority to bind
              the other to third parties.
            </li>
            <li>
              <b>) FORCE MAJEURE: </b>The Company is not liable for any failure
              to perform due to causes beyond its reasonable control including,
              but not limited to, acts of God, acts of civil authorities, acts
              of military authorities, riots, embargoes, acts of nature and
              natural disasters, and other acts which may be due to unforeseen
              circumstances.
            </li>
            <li>
              <b>j) CONTACT: </b>For any additional information about the
              project, please contact us at alpha@aperians.com
            </li>
          </ul>
        </Fade>
      </div>
    </Layout>
  );
}
